import React from 'react';
import bike from '../../assets/projects/bike.png';
import health from '../../assets/projects/health.png';
import resort from '../../assets/projects/Royals.png';
import school from '../../assets/projects/school.png';

const projects = [
    {
        image: bike,
        title: 'PADROLO MOTORS',
        overview: [
            'A full-stack web application for a bike shop.',
            'Bike sales Website. Users can choose bikes, view details, and buy bikes.',
            'Users can Add/Delete orders & give ratings. Ratings are shown on the homepage.',
            'Admin can manage all products, make admin, and cancel any order.',
            'For testing as Admin, use email: admin@admin.com with password: 123456.'
        ],
        technologies: ['HTML5', 'CSS3', 'React Bootstrap', 'React', 'React Hooks', 'React Router', 'Node JS', 'Express JS', 'MongoDB', 'Firebase'],
        liveLink: 'https://padrolo-motors.web.app/',
        codeClient: 'https://github.com/saiful-shant0/padrolo-motors-Client',
        codeServer: 'https://github.com/saiful-shant0/padrolo-motors-server'
    },
    {
        image: school,
        title: 'Silicone Online School',
        overview: [
            'An online school platform for educational purposes.',
            'Users can book courses and services related to education.',
            'Users can see details in the menu bar and sign in with Google and email-password.'
        ],
        technologies: ['HTML5', 'CSS3', 'React Bootstrap', 'React', 'React Hooks', 'React Router', 'Node JS', 'Express JS', 'MongoDB', 'Firebase'],
        liveLink: 'https://silicone-dev-school.netlify.app/',
        codeClient: 'https://github.com/ProgrammingHeroWC4/review-website-saiful-shant0.git',
        codeServer: 'https://github.com/ProgrammingHeroWC4/review-website-saiful-shant0.git'
    },
    {
        image: health,
        title: 'Motion Health Care',
        overview: [
            'A healthcare website for booking health-related services like ICU, NICU.',
            'Users can book services in advance and request for blood.',
            'Users can see details in the menu bar and sign in with Google and email-password.'
        ],
        technologies: ['HTML5', 'CSS3', 'React Bootstrap', 'React', 'React Hooks', 'React Router', 'Node JS', 'Express JS', 'MongoDB', 'Firebase'],
        liveLink: 'https://motion-health-care.web.app/',
        codeClient: 'https://github.com/saiful-shant0/motion-health-care',
        codeServer: 'https://github.com/saiful-shant0/motion-health-care'
    },
    {
        image: resort,
        title: 'Royals Resort',
        overview: [
            'A resort booking website.',
            'After logging in, a user can book services in advance.',
            'Logged in users can see their details in the menu bar and sign in with Google.'
        ],
        technologies: ['HTML5', 'CSS3', 'React Bootstrap', 'React', 'React Hooks', 'React Router', 'Node JS', 'Express JS', 'MongoDB', 'Firebase'],
        liveLink: 'https://royals-resort.web.app/home',
        codeClient: 'https://github.com/saiful-shant0/Royal-resort-client',
        codeServer: 'https://github.com/saiful-shant0/royal-resort-server'
    }
];

const Project = () => {
    return (
        <>
            <h2><span className='text-blue-500'>P</span>rojects</h2>
            <hr className="my-4" />

            <div className="grid gap-8 lg:grid-cols-2">
                {projects.map((project, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg shadow-lg">
                        <img className="rounded-t-lg" src={project.image} alt={project.title} />
                        <div className="p-5">
                            <h4 className="mb-2 text-xl text-blue-500 tracking-tight">{project.title}</h4>
                            <h6 className='pb-1'>Project Overview:</h6>
                            <ul className='text-sm text-gray-500 pb-4'>
                                {project.overview.map((item, idx) => (
                                    <li key={idx}>• {item}</li>
                                ))}
                            </ul>
                            <h6 className='pb-2'>Technology Uses:</h6>
                            <p className='pb-4 space-x-2'>
                                {project.technologies.map((tech, idx) => (
                                    <span
                                        key={idx}
                                        className='inline-block px-3 py-1 my-1 rounded-full bg-blue-100 text-blue-800 hover:bg-blue-200 hover:text-blue-900 transition duration-200 ease-in-out cursor-pointer'
                                    >
                                        {tech}
                                    </span>
                                ))}
                            </p>
                            <a className="rounded border border-blue-500 py-2 px-2 m-2 hover:bg-blue-200 text-black focus:outline-none" href={project.liveLink} target='_blank' rel='noreferrer'>Live link</a>
                            <a className="rounded border border-blue-500 py-2 px-2 m-2 hover:bg-blue-200 text-black focus:outline-none" href={project.codeClient} target='_blank' rel='noreferrer'>Code Client</a>
                            {project.codeServer && (
                                <a className="rounded border border-blue-500 py-2 px-2 m-2 hover:bg-blue-200 text-black focus:outline-none" href={project.codeServer} target='_blank' rel='noreferrer'>Code Server</a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Project;
